<template>
  <div style="position:relative;">
    <div class="rasgado rasgado-top"></div>

    <section class="itinerario-poster" ref="sectionRef">
      <div class="stars-container">
        <div class="stars sky-density-1"></div>
        <div class="stars sky-density-2"></div>
        <div class="stars sky-density-3"></div>
        
        <div class="glow-sparkle sp-1"></div>
        <div class="glow-sparkle sp-2"></div>
        <div class="glow-sparkle sp-3"></div>
        <div class="glow-sparkle sp-4"></div>
        <div class="glow-sparkle sp-5"></div>
        <div class="glow-sparkle sp-6"></div>
      </div>

      <h2 class="poster-title">Itinerario</h2>
      <span class="sub">
        Agradecemos tu puntualidad. <br />
        ¡No queremos empezar sin ti ni que te pierdas ningun momento especial! Llega a tiempo para compartir cada instante de esta noche.
      </span>
      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: ' Llegada y Bienvenida de los Invitados',
        hora: '6:30 PM',
        icono: require('@/assets/valss.png')
      },
      {
        nombre: ' Hora del Cóctel',
        hora: '7:00 PM',
        icono: require('@/assets/copa.png')
      },
      {
        nombre: ' Ceremonia de la Quinceañera',
        hora: '7:45 PM',
        icono: require('@/assets/mon.png')
      },
      {
        nombre: ' Cena',
        hora: '8:30 PM',
        icono: require('@/assets/cen.avif')
      },
      {
        nombre: 'Baile Sorpresa ',
        hora: '9:30 PM ',
        icono: require('@/assets/baile.png')
      },
      {
        nombre: '¡Hora de la Fiesta, Baile, Música y la Hora Loca! ',
        hora: '10:00 PM - 12:30 AM',
        icono: require('@/assets/fiesta.avif')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>

<style scoped>
.itinerario-poster {
  background: #f0c9d3;
  padding: 60px 20px 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

/* Contenedor de estrellas */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.stars {
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
}

/* Capa 1: Gran densidad de estrellas blancas con destello radial */
.sky-density-1 {
  background-image: 
    radial-gradient(2px 2px at 8% 12%, #fff 100%, transparent),
    radial-gradient(3px 3px at 15% 28%, #fff 80%, transparent),
    radial-gradient(2px 2px at 24% 16%, #fff 100%, transparent),
    radial-gradient(3px 3px at 35% 34%, #fff 80%, transparent),
    radial-gradient(2px 2px at 47% 10%, #fff 100%, transparent),
    radial-gradient(3px 3px at 58% 25%, #fff 80%, transparent),
    radial-gradient(2px 2px at 69% 15%, #fff 100%, transparent),
    radial-gradient(3px 3px at 82% 30%, #fff 80%, transparent),
    radial-gradient(2px 2px at 91% 11%, #fff 100%, transparent),
    radial-gradient(3px 3px at 96% 23%, #fff 80%, transparent),
    radial-gradient(2px 2px at 5% 55%, #fff 100%, transparent),
    radial-gradient(3px 3px at 19% 64%, #fff 80%, transparent),
    radial-gradient(2px 2px at 29% 48%, #fff 100%, transparent),
    radial-gradient(3px 3px at 38% 76%, #fff 80%, transparent),
    radial-gradient(2px 2px at 44% 58%, #fff 100%, transparent),
    radial-gradient(3px 3px at 53% 88%, #fff 80%, transparent),
    radial-gradient(2px 2px at 66% 54%, #fff 100%, transparent),
    radial-gradient(3px 3px at 74% 72%, #fff 80%, transparent),
    radial-gradient(2px 2px at 85% 61%, #fff 100%, transparent),
    radial-gradient(3px 3px at 93% 86%, #fff 80%, transparent);
  animation: ultraTwinkle 2s infinite ease-in-out alternate;
}

/* Capa 2: Estrellas medianas duplicando los puntos de luz */
.sky-density-2 {
  background-image: 
    radial-gradient(2.5px 2.5px at 11% 22%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 22% 42%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 40% 20%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 64% 38%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 77% 18%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 88% 44%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 13% 72%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 31% 54%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 50% 66%, #fff, transparent),
    radial-gradient(3.5px 3.5px at 71% 82%, #fff, transparent),
    radial-gradient(2.5px 2.5px at 83% 69%, #fff, transparent);
  animation: ultraTwinkle 3.5s infinite ease-in-out alternate-reverse;
}

/* Capa 3: Halos de brillo grande difuminado */
.sky-density-3 {
  background-image: 
    radial-gradient(7px 7px at 18% 15%, rgba(255,255,255,0.9) 0%, transparent 80%),
    radial-gradient(8px 8px at 45% 45%, rgba(255,255,255,0.85) 0%, transparent 80%),
    radial-gradient(7px 7px at 78% 22%, rgba(255,255,255,0.9) 0%, transparent 80%),
    radial-gradient(9px 9px at 88% 75%, rgba(255,255,255,0.85) 0%, transparent 80%),
    radial-gradient(7px 7px at 32% 68%, rgba(255,255,255,0.9) 0%, transparent 80%),
    radial-gradient(8px 8px at 62% 12%, rgba(255,255,255,0.9) 0%, transparent 80%);
  animation: ultraTwinkle 2.8s infinite ease-in-out;
}

/* Grandes destellos mágicos de 4 puntas */
.glow-sparkle {
  position: absolute;
  width: 3px;
  height: 3px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 10px 2px #fff;
}
.glow-sparkle::before, .glow-sparkle::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(to right, transparent, #fff, transparent);
}
/* Línea horizontal del destello */
.glow-sparkle::before { width: 26px; height: 1.5px; }
/* Línea vertical del destello */
.glow-sparkle::after { width: 1.5px; height: 26px; }

/* Posiciones estratégicas de los destellos brillantes */
.sp-1 { top: 15%; left: 12%; animation: burst 4s infinite ease-in-out; }
.sp-2 { top: 38%; left: 82%; animation: burst 4.5s infinite ease-in-out 1s; }
.sp-3 { top: 62%; left: 25%; animation: burst 3.8s infinite ease-in-out 0.5s; }
.sp-4 { top: 18%; left: 55%; animation: burst 5s infinite ease-in-out 2s; }
.sp-5 { top: 78%; left: 72%; animation: burst 4.2s infinite ease-in-out 1.5s; }
.sp-6 { top: 50%; left: 88%; animation: burst 3.2s infinite ease-in-out 0.7s; }

/* Animación de parpadeo continuo y fuerte */
@keyframes ultraTwinkle {
  0% { opacity: 0.2; transform: scale(0.93); }
  50% { opacity: 1; transform: scale(1.08); filter: drop-shadow(0 0 3px #fff); }
  100% { opacity: 0.3; transform: scale(0.95); }
}

/* Animación para que los destellos cruzados brillen y crezcan */
@keyframes burst {
  0%, 100% { transform: scale(0); opacity: 0; }
  50% { transform: scale(1.2); opacity: 1; }
}

/* Estructura del contenido superior */
.poster-title, .sub, .poster-item {
  position: relative;
  z-index: 2;
}

.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #514e4e;
  margin-bottom: 50px;
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #282727;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #fff;
  z-index: 5;
  pointer-events: none;
}

.rasgado-top {
  top: 0;  background:#f0c9d3;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}

.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
}

.sub {
  font-family: 'Playfair Display', serif;
  color: #3d3939;
  line-height: 1.4;
  position: relative;
  z-index: 2;
  display: block;
  margin-bottom: 30px;
  margin-top:-20px;
  opacity: 1;
}
</style>